import commonSaga from "./common/sagas";
import userSaga from "./user/sagas";

export default [commonSaga(), userSaga()];
